import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
// import {View, Text, StyleSheet, ScrollView, Alert} from 'react-native';
// import FormInput from '../components/FormInput';
// import CustomButton from '../components/CustomButton';
// import {useNavigation} from '@react-navigation/native';
// import {useForm} from 'react-hook-form';
// import {NewPasswordNavigationProp} from '../../../Types/navigation';
import { confirmResetPassword } from 'aws-amplify/auth';
import { useTranslation } from 'react-i18next';
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import CustomModal from '../../../components/Modals/CustomModal';
import { IoEye, IoEyeOff } from "react-icons/io5";
// import { I18n } from 'i18n-js';
// import translations from "../../../../locales/translation.json";
// import * as RNLocalize from "react-native-localize";

const normalizeLocale = (locale: string): string => {
  const match = locale.match(/^[a-zA-Z]+/);
  return match ? match[0] : "en";//locale;
};

type NewPasswordType = {
  // email: string;
  username: string;
  code: string;
  password: string;
};

const NewPasswordScreen = () => {
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);

  // VALIDATION
  const [passwordHidden, setPaswordHidden] = useState(true);
  const [loading, setLoading] = useState(false);
  const {register, control, handleSubmit, watch, reset} = useForm<NewPasswordType>();

  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('title.newPassword');
  }, []);

  const onSubmitPressed = async (data: NewPasswordType) => {
    if (loading) {
      return;
    };
    setLoading(true);
    try {
      console.log(data);
      await confirmResetPassword({username: data.username, confirmationCode: data.code, newPassword: data.password});
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t("signup.newPasswordTitleAlert")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t("signup.newPasswordAlertMessage")}</p>
        </Modal.Body></>);
      setLinkModal('/signIn');
      setShowCustomModal(true);
      setLoading(false);
      
      // navigate('/cognito/signIn');
    } catch (error: any) {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t("signup.error")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{error.message || "Something went wrong"}</p>
        </Modal.Body></>);
      setShowCustomModal(true);
      // alert("Error", error.message || "Something went wrong");
    }
    setLoading(false);
    reset();
  };

  const onSignInPress = () => {
    navigate('/signIn');
  };

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        // animation={true}
      />
      <Form className="register-form">
        <h2 className="text-center">{t('signup.new_password')}</h2>
        <Container className="">
        {/* <Form className="d-flex align-items-end">  */}
          {/* <Row className="align-items-end">
            <Col> */}
              <InputGroup>
                <Form.Control
                  name="username"
                  // control={control}
                  placeholder={t("signup.email")}
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("username")}
                  aria-label="Username"
                />
              </InputGroup>

              <InputGroup>
                <Form.Control
                  name="code"
                  // control={control}
                  placeholder={t("signup.code")}
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("code")}
                  aria-label="Code"
                />
              </InputGroup>

              <InputGroup>
                <Form.Control
                  type={passwordHidden ? "password" : "text"}
                  name="password"
                  // control={control}
                  placeholder={t("signup.password")}
                  aria-describedby="basic-addon1"
                  className="d-inline me-lg-2"
                  {...register("password")}
                  aria-label="Password"
                />
                { passwordHidden ?
                  <IoEye onClick={() => setPaswordHidden(false)} name="eye" size={30} color="#000" style={{position: 'absolute', right: 15, top: 5}}/>
                : 
                  <IoEyeOff onClick={() => setPaswordHidden(true)} name="eye-slash" size={30} color="#000" style={{position: 'absolute', right: 15, top: 5}} />
                }
              </InputGroup>

              
              <InputGroup>
                <Button type="submit" onClick={handleSubmit(onSubmitPressed)}>{loading ? t('signup.loading') : t("signup.send")}</Button>
                {/* <Button type="button" onClick={goToRegister}>Register</Button> */}
              </InputGroup>
            {/* </Col>
          </Row> */}
          </Container>
        </Form>
      </>
    // <ScrollView showsVerticalScrollIndicator={false}>
    //   <View style={styles.root}>
    //     <Text style={styles.title}>{i18n.t("signUp.resetPasswordTitle")}</Text>

    //     <FormInput
    //       name="username"
    //       control={control}
    //       placeholder={i18n.t("signUp.email")}
    //       rules={{required: i18n.t("signUp.emailRequired")}}
    //     />

    //     <FormInput
    //       name="code"
    //       control={control}
    //       placeholder={i18n.t("signUp.code")}
    //       rules={{required: i18n.t("signUp.codeRequired")}}
    //     />

    //     <FormInput
    //       name="password"
    //       control={control}
    //       placeholder={i18n.t("signUp.newPassword")}
    //       secureTextEntry
    //       rules={{
    //         required: i18n.t("signUp.passwordRequired"),
    //         minLength: {
    //           value: 8,
    //           message: i18n.t("signUp.passwordMin"),
    //         },
    //       }}
    //     />

    //     <CustomButton text={loading ? i18n.t('signUp.loading') : i18n.t("profile.submit")} onPress={handleSubmit(onSubmitPressed)} />

    //     <CustomButton
    //       text={i18n.t("signUp.backToSignIn")}
    //       onPress={onSignInPress}
    //       type="TERTIARY"
    //     />
    //   </View>
    // </ScrollView>
  );
};

export default NewPasswordScreen;
